import React, { useEffect } from 'react';
import * as S from './style';
import { lightWhite } from '../shared-styles/Colors';
import { breakpoints, MediaQuery } from '../../../utils/responsive_utilities';
import { trackToGtmFE } from '../../../utils/gtm-event-common';
import { getCookie } from '../../../utils/web-helper';
import { footerUsData } from './footer_us_data';
import { footerUkData } from './footer_uk_data';
import { footerAuData } from './footer_au_data';

// [AI GENERATED CODE]
// Seal API returns the app certificate link (splashmath_allgrades_app); web should open the splashlearn member page instead
const KIDSAFE_WEB_MEMBER_URL = 'https://kidsafe.com/member/splashlearn';
const onClickKidsafeSeal = (e) => {
  const anchor = e.target.closest && e.target.closest('#ksp-seals a');
  if (!anchor) return;
  e.preventDefault();
  window.open(KIDSAFE_WEB_MEMBER_URL, '_blank', 'noopener,noreferrer');
};

const Footer = () => {
  const onClickGTMFooter = (eventParams) => {
      trackToGtmFE('clicked_footer',eventParams);
  }

  // [AI GENERATED CODE]
  // Injects preconnect hint + KidSafe seal script on mount for faster badge load
  useEffect(() => {
    if (!document.querySelector('link[href="https://kidsafe.com"][rel="preconnect"]')) {
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://kidsafe.com';
      document.head.appendChild(preconnect);
    }
    if (!document.getElementById('ksp-seals-script')) {
      const script = document.createElement('script');
      script.id = 'ksp-seals-script';
      script.async = true;
      script.setAttribute('data-product', 'okHgakwZiV7ujcdz8unVrzpsyOGLhyPpuQCgB36R');
      script.src = 'https://kidsafe.com/js/seals/seals.js';
      document.body.appendChild(script);
    }
  }, []);
  
  return (
    <S.Wrapper>
      <div className="content-container">
        <S.Flex1>
          {linksArr.map((linkset, index) => {
            return (
              <S.List key={index}>
                <S.ListItem>{linkset.mainLink}</S.ListItem>
                {linkset.sublinks.map((sublink, subindex, links) => {
                  return (
                    <S.ListItem sublink key={sublink.title}>
                      <a
                        href={sublink.link}
                        target={sublink.target ? '_target' : ''}
                        onClick={() => onClickGTMFooter({'Click Text': sublink.title,'Click URL': sublink.link})}
                      >
                        {sublink.title}
                      </a>
                    </S.ListItem>
                  );
                })}
              </S.List>
            );
          })}
        </S.Flex1>
        <MediaQuery query={`(min-width: ${breakpoints.xl}px)`}>
          <S.Line></S.Line>
        </MediaQuery>
        <S.Flex2>
          <div>
            <S.ListItem as="span">
              <a href="/terms-of-use" onClick={() => onClickGTMFooter({'Click Text': 'Terms of use','Click URL': '/terms-of-use'})}>Terms of use</a>
            </S.ListItem>
            <span style={{ color: lightWhite }}>{' | '}</span>
            <S.ListItem as="span">
              <a href="/privacy" onClick={() => onClickGTMFooter({'Click Text': 'Privacy Policy','Click URL': '/privacy'})} >Privacy Policy</a>
            </S.ListItem>
            <span style={{ color: lightWhite }}>{' | '}</span>
            <S.ListItem as="span">
              <a href="/cookies_info_setting" onClick={() => onClickGTMFooter({'Click Text': 'Cookie Policy and Preference Center','Click URL': '/cookies_info_setting'})} >Cookie Policy and Preference Center</a>
            </S.ListItem>
            <S.Trademarks>
              StudyPad & SplashLearn are registered Trademarks of StudyPad, Inc.{' '}
            </S.Trademarks>
          </div>
          {/* [AI GENERATED CODE] KidSafe seal rendered via JS snippet; script injected in useEffect */}
          <S.KidsafeDiv onClickCapture={onClickKidsafeSeal} onClick={() => onClickGTMFooter({'Click Text': 'Kid Safe','Click URL': KIDSAFE_WEB_MEMBER_URL})}>
            <div style={{ flexGrow: 1 }}></div>
            <div id="ksp-seals"></div>
          </S.KidsafeDiv>
        </S.Flex2>
      </div>
    </S.Wrapper>
  );
};

const countryCode = localStorage.getItem('user_preferred_language') || getCookie('user_preferred_language') || 'en';

const linksArr = countryCode == 'en-GB' ? footerUkData : (countryCode == 'en-AU' ? footerAuData : footerUsData);

export default Footer;
